import React, {useEffect} from 'react';
import './ProjectsNewFile.scss';
import Dropzone from '../../Dropzone';
import {ButtonMUI, InputMUI} from '../../../../shared';
import RadioMUI from '../../../../shared/RadioMUI';
import AvatarImg from '../../../../assets/icons/avatarDoc.png';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {Controller, useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {
  createDocument,
  getDocuments,
  getDrawings,
  getEstimates
} from '../../../../redux/actions/documents/documentsActions';
import {useParams} from 'react-router-dom';
import {notifyError} from '../../../../helpers/notifySnack';
import {
  getProject,
  getProjectMembersList} from '../../../../redux/actions/projects/projectsActions';
import LoadPanel from '../../LoadPanel';
import {useTranslation} from 'react-i18next';

const ProjectsNewFile = ({type, setShowNewFile}) => {
  const {t} = useTranslation();
  const {id} = useParams();
  const dispatch = useDispatch();
  const {projectMembersList, projectMembersListLoading} = useSelector((state) => state.projects);

  const validationSchema = yup.object().shape({
    documentName: yup.string().required(t('all.documentNameError'))
  });

  const {
    handleSubmit,
    control,
    watch,
    formState: {errors, isValid, isSubmitting},
    setValue
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      documentName: '',
      files: []
    }
  });

  const filesWatch = watch('files');

  const onFilesAdded = (files) => {
    setValue('files', files);
  };

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append('type', type);
    formData.append('name', data.documentName);
    if (data.files.length) {
      formData.append('file[0]', data.files[0]);
    }

    const response = await dispatch(createDocument(id, formData));

    if (response?.payload) {
      setShowNewFile(false);
      await dispatch(getProject(id,true));
      if (type === 'document') {
        await dispatch(getDocuments(id, type));
      }
      if (type === 'estimate') {
        await dispatch(getEstimates(id, type));
      }
      if (type === 'drawing') {
        await dispatch(getDrawings(id, type));
      }
    }
  };

  const clients = projectMembersList?.clients?.filter((el) => {
    return el.role === 'user';
  });

  useEffect(() => {
    const fetchFunc = async () => {
      if (id) {
        try {
          await dispatch(getProjectMembersList(id));
        } catch (e) {
          console.log(e);
        }
      }
    };
    fetchFunc();
  }, [id]);

  useEffect(() => {
    if (!projectMembersListLoading) {
      if (!clients.length && type !== 'estimate') {
        notifyError(t('all.addClient'));
        return setShowNewFile(false);
      }
    }
  }, [projectMembersListLoading]);

  if (projectMembersListLoading) {
    return <LoadPanel noBg={true} circleSize={40} staticPos={true} />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='projects__new'>
      <div className='projects__new-title'>{t('all.downloadNew')}</div>
      <div className='projects__new-dropzone'>
        <Dropzone
          allowFormats={['.jpg', '.jpeg', '.png', '.pdf', '.docx', '.doc', '.txt', '.ppt', '.pptx', '.xlsx', '.xls']}
          maxSizeMb={50}
          onFilesAdded={onFilesAdded}
        />
      </div>
      <div className='projects__new-input'>
        <Controller
          name='documentName'
          control={control}
          render={({field}) => (
            <InputMUI
              className={'no-icons'}
              fullWidth
              error={errors.email?.message}
              inputProps={{
                ...field,
                maxLength: 200
              }}
              label={t('all.documentName')}
            />
          )}
        />
      </div>

      {clients.length && type !== 'estimate' ? (
        <>
          <div className='projects__new-radio'>
            <RadioMUI label={t('all.request')} checked={true} />
          </div>
          <div className='projects__new-list'>
            <div className='projects__new-item'>
              <div className='projects__new-img'>
                <img src={clients[0].avatar ? clients[0].avatar : AvatarImg} alt='avatar' />
              </div>
              <div className='projects__new-data'>
                <div className='projects__new-name'>{clients[0].firstName}</div>
                <div className='projects__new-role'>{clients[0].roleName}</div>
              </div>
            </div>
          </div>
        </>
      ) : (
        ''
      )}

      <div className='projects__new-submit'>
        <ButtonMUI
          type='submit'
          fullWidth={true}
          onClick={handleSubmit(onSubmit)}
          loading={isSubmitting}
          disabled={!isValid || filesWatch.length === 0 || isSubmitting}
        >
          {t('ProjectsReports.common.Download')}
        </ButtonMUI>
      </div>
    </form>
  );
};

export default ProjectsNewFile;
